export default "__VITE_ASSET__DRiczizR__"